var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.wasWatched)?_c('img',{attrs:{"src":require("@/assets/images/wasWatched.png"),"alt":""}}):_c('img',{attrs:{"src":require("@/assets/images/wasNotWatched.png"),"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }